import { useMonitor } from '../use-monitor';

export function useMonitorCreateIssueFormSubmit() {
  return useMonitor('create-issue-form-submit');
}
